<script lang="ts">
  // The blue Timepeak wing surface from the timepeak.nl hero, as a banner.
  // Content inside is white; use Button variants 'inverse' / 'inverse-outline'.
  import type { Snippet } from 'svelte';
  let { children, actions, compact = false }: { children: Snippet; actions?: Snippet; compact?: boolean } = $props();
</script>

<section class="banner" class:compact>
  <img class="wing" src="/brand/wing.webp" alt="" aria-hidden="true" decoding="async" />
  <div class="content">{@render children()}</div>
  {#if actions}<div class="actions">{@render actions()}</div>{/if}
</section>

<style>
  .banner {
    position: relative;
    isolation: isolate;
    overflow: hidden;
    /* Text and actions stay on the solid blue at the left; the feathers at the
       right are decoration, as in the landing page hero. */
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--space-4);
    padding: var(--space-6) clamp(var(--space-8), 22%, 280px) var(--space-6) var(--space-8);
    border-radius: var(--radius-lg);
    /* The page colour shows through the gaps between the feathers. */
    background: var(--surface);
    color: var(--on-brand);
    box-shadow: var(--shadow-sm);
  }
  .compact { padding: var(--space-5) var(--space-6); }
  /* The feathered edge sits at the right, as on the landing page. */
  .wing {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: max(125%, 760px);
    height: auto;
    max-width: none;
    z-index: -1;
    pointer-events: none;
    user-select: none;
  }
  .content { display: flex; flex-direction: column; gap: var(--space-1); min-width: 0; }
  .content :global(h1), .content :global(h2) { color: var(--on-brand); }
  .content :global(p) { color: var(--on-brand-2); }
  .actions { display: flex; gap: var(--space-2); flex-wrap: wrap; }
  @media (max-width: 640px) {
    /* Phones: the solid part of the wing only, so text and buttons stay readable. */
    .banner { padding: var(--space-5); align-items: stretch; }
    .wing { right: auto; left: -12%; width: max(220%, 760px); }
    .actions { width: 100%; }
    .actions :global(.btn) { flex: 1; }
  }
</style>
